import React from "react";

const Notes = (props: any) => {
  const { subscriptionData } = props;
  return (
    <>
      <div className={"font-jost text-center text-xs font-normal leading-3.5 text-gray-1 mb-10 lg:mb-[72px]"}>
        {/*<div className={"mb-4"}>*/}
        {/*  *Savings shown relate to tickets in the BOTB Pass Ultimate yearly subscription vs. buying tickets separately.*/}
        {/*</div>*/}
        {/*<div>*/}
        {/*  The advertised offer applies to{" "}*/}
        {/*  <strong className={"font-medium text-secondary leading-4"}>*/}
        {/*    new subscribers who purchase a BOTB subscription*/}
        {/*  </strong>{" "}*/}
        {/*  until 14 February 2026.*/}
        {/*  <strong className={"font-medium text-secondary leading-4"}>*/}
        {/*    The £14 value is based on the standard purchase price*/}
        {/*  </strong>{" "}*/}
        {/*  of 14 Dream House tickets. Tickets are a non-cash benefit and cannot be exchanged for money.{" "}*/}
        {/*  <a href={"/terms"} title={"Terms and Conditions apply"} className={"underline cursor-pointer"}>*/}
        {/*    Terms and Conditions apply*/}
        {/*  </a>*/}
        {/*</div>*/}

        <div className={"mb-4"}>{subscriptionData.header.legalText}</div>
        <div>
          <a href={"/terms"} title={"Terms and Conditions apply"} className={"underline cursor-pointer"}>
            Terms and Conditions apply
          </a>
        </div>
      </div>
    </>
  );
};

export default Notes;
